export default __webpack_public_path__ + "static/media/noRecord.dfbd33fe.svg";